import React, { useEffect, useState } from "react";
import {
    EuiFormRow,
    EuiFilePicker,
    EuiButtonEmpty,
    EuiFlexGroup,
    EuiFlexItem,
    EuiIcon,
    EuiSpacer,
} from "@elastic/eui";
import _ from "lodash";

import * as S from "../../../style";
import Thumbnail from "../../../../Thumbnail/Thumbnail";
import { readMultiFiles } from "../../../../../../utils/readFiles";

const renderUploadIcon = (isReupload, initialText = "Click or drag to upload") => (
    <>
        <EuiIcon
            type={isReupload ? "refresh" : "share"}
            size="l"
        />
        <EuiSpacer size="s" />
        <small>{isReupload ? "Click or drop to re-upload" : initialText}</small>
    </>
);

function AbstractFile({ options, errors, onFileUpload, onFileRemove, selectedFiles }) {
    const [inputKey, setInputKey] = useState(Math.random().toString(36));
    const [files, setFiles] = useState([...(selectedFiles || [])]);

    // a workaround to clear input by changing container key which forces React to
    // render the input again
    const clearInputValue = () => {
        const randomString = Math.random().toString(36);
        setInputKey(randomString);
    };

    useEffect(() => {
        setFiles(selectedFiles || []);
        clearInputValue();
    }, [selectedFiles]);

    const removeFile = (i) => {
        const filesClone = [...files];
        filesClone.splice(i, 1);

        setFiles(filesClone);
        onFileRemove(options.name, filesClone);
    };

    const uploadFiles = (name, fileList) => {
        if (fileList.length === 0) {
            onFileUpload(name, []);
            setFiles([]);
            clearInputValue();
            return;
        }

        readMultiFiles(
            fileList,
            (result) => {
                onFileUpload(name, result);
                setFiles(result);
                clearInputValue();
            },
            (err) => {
                console.log(err);
            }
        );
    };

    const handleChange = (files) => {
        if (files.length) {
            uploadFiles(options.name, files);
        }
    };

    return (
        <S.AbstractFileWrapper>
            <S.AbstractFileFormRow>
                <EuiFormRow
                    id={options.name}
                    key={inputKey || ""}
                    fullWidth
                    label={options.label}
                    isInvalid={!_.isNil(errors[options.name])}
                    error={options.errorMessage}
                >
                    <EuiFilePicker
                        name={options.name}
                        initialPromptText={options.initialPromptText}
                        onChange={handleChange}
                        display="large"
                        fullWidth
                        multiple
                        accept={options.accept}
                    />
                </EuiFormRow>
                <div className="asbtract-file__preview">
                    {renderUploadIcon(!!files.length, options.initialPromptText)}
                </div>
            </S.AbstractFileFormRow>
            <EuiFlexGroup
                gutterSize="none"
                className="files-thumbnail"
                responsive={false}
                wrap
            >
                {files.map((file, i) => (
                    <EuiFlexItem
                        className="abstract-file__thumbnail-wrapper"
                        grow={false}
                        key={file && file.name ? file.name : i}
                    >
                        <Thumbnail
                            src={file.value}
                            title={file.name}
                            alt="file thumbnail"
                        />
                        {onFileRemove && (
                            <EuiButtonEmpty
                                color="danger"
                                size="xs"
                                type="button"
                                onClick={() => removeFile(i)}
                            >
                                <small>Remove file</small>
                            </EuiButtonEmpty>
                        )}
                    </EuiFlexItem>
                ))}
            </EuiFlexGroup>
        </S.AbstractFileWrapper>
    );
}

export default AbstractFile;
